export const getQueryParams = (currentPage, dateHeaderId, sorting) => ({
    page: currentPage - 1,
    sortDirection: sorting && sorting.headerId === dateHeaderId
        ? sorting.direction.toUpperCase()
        : undefined,
});
